export class LINQUtil {
    static firstOrDefault<T>(arr: T[], filter: (v: T) => boolean) {        
        let filtered = arr.filter(filter);
        if (filtered.length > 0) return filtered[0];
        return undefined;
    }
}